import styled, { createGlobalStyle, css } from 'styled-components';

import { overlay } from 'styled';

export const AddButton = styled.div`
  width: 20px;
  height: 20px;
  background: ${props => props.theme.colors.primary.main};

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  cursor: pointer;
`;

export const GlobalStyle = createGlobalStyle`
  .ant-popover-inner-content {
    padding: 0px;
  }
`;

export const PartnerNoteWrapper = styled.div`
  width: 100%;
  height: calc(100% - 160px);
`;

export const PartnerNoteHeader = styled.div`
  padding: ${p => p.theme.app.padding.vertical} 24px;
  border-bottom: 1px solid #efefef;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PartnerNoteContent = styled.div`
  width: 100%;
  height: 100%;

  overflow: scroll;

  ${overlay}
`;

export const PartnerNoteEditorWrapper = styled.div`
  width: 100%;
  padding: 14px 24px 8px 24px;

  display: flex;

  .ant-form-item {
    margin: 0;

    textarea {
      color: ${props => props.theme.colors.text.secondary};
      font-weight: ${props => props.theme.font.weight.medium};

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  gap: 8px;
`;

export const PartnerDescriptionNoteEditorWrapper = styled.div`
  width: 100%;
  padding: 6px 24px 6px 0px;

  display: flex;

  .ant-form-item {
    margin: 0;

    textarea {
      font-size: ${props => props.theme.font.size.xxs};
      font-weight: ${props => props.theme.font.weight.medium};
      color: ${props => props.theme.colors.text.secondary};
      padding: 4px 12px;
      min-height: 42px !important;
      max-height: 62px !important;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
`;

export const PartnerNoteItemWrapper = styled.div`
  padding: 6px 0px;

  border-bottom: 1px solid #efefef;
`;

export const PartnerNoteDescriptionWrapper = styled.div`
  padding-left: 48px;
`;

export const Color = styled.div<{ color?: string }>`
  width: 16px;
  height: 16px;
  background: ${props => props.color ?? props.theme.colors.primary.main};

  border-radius: 3px;

  flex-shrink: 0;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  background: #e1e1e1;

  margin-top: 6px;

  border-radius: 50%;

  flex-shrink: 0;
`;

export const PartnerNoteTitleItemWrapper = styled.div`
  width: 100%;
  padding: 12px 24px 6px 24px;

  display: flex;
  align-items: flex-start;
  gap: 6px;

  .note-title-action {
    visibility: hidden;
  }

  &:hover {
    .note-title-action {
      visibility: visible;
    }
  }
`;

export const PartnerDescriptionItemEditorWrapper = styled.div`
  width: 100%;
  padding: 6px 24px 6px 0px;

  display: flex;
  align-items: flex-start;
  gap: 6px;

  .note-description-action {
    visibility: hidden;
  }

  &:hover {
    .note-description-action {
      visibility: visible;
    }
  }
`;

export const Wrapper = styled.div`
  text-align: left;
  height: 100%;
`;

export const MobileWrapper = styled.div`
  padding: ${p => p.theme.app.padding.horizontal};
`;

export const ModalStyles = css`
  .ant-modal-body {
    padding: 0px !important;
    padding-bottom: 12px !important;
  }
`;

export const UpdateCodeFormWrapper = styled.div`
  padding: ${p => p.theme.app.padding.horizontal};

  .ant-form-item {
    margin: 0;
  }
`;
